import favouriteService from '../../services/favouriteService';
export default {
  namespaced: true,
  state: {
    favourites: []
  },
  getters: {},
  mutations: {
    SET_FAVOURITES_FROM_LOCAL(state){
      state.favourites = favouriteService.getFavourites();
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    toggleFavourite({ commit, dispatch }, station) {
      station.playing = null;
      const wasFavourite = favouriteService.getFavouriteByName(station.name) !== null;
      favouriteService.addFavourite(station, true);
      commit('SET_FAVOURITES_FROM_LOCAL', true);

      // Log the toggle action with context
      const toggleAction = wasFavourite ? 'RemovedFavourite' : 'AddedFavourite';
      const description = wasFavourite ? `Removed ${station.name} from favourites` : `Added ${station.name} to favourites`;
      const action = wasFavourite ? 'Removed from favourites' : 'Added to favourites';

      const logData = {
        action: toggleAction,
        description,
        meta: {
          station: station,
          action: action,
          source: 'toggle_action'
        },
      };

      dispatch('sendLog', {
        action: toggleAction,
        description,
        meta: logData.meta
      }, { root: true });

      if (window.flutter_inappwebview) {
        const handler = window.flutter_inappwebview.callHandler || window.flutter_inappwebview._callHandler;
        if (typeof handler === 'function') {
          handler("logHandler", logData)
        }
      }

      // Return whether the station is now favourited (opposite of wasFavourite)
      return !wasFavourite;
    },
  }
};
